<div
  class="document-item"
  (click)="onContainerClick()"
  [class.inserted]="shouldShowInsertedBorder"
  [class.c-pointer]="!shouldShowInsertedBorder"
  [class.required]="sent && !hasValue"
>
  <div
    class="right-icons-container"
    [class.d-none]="hideCloseButton"
    (click)="remove($event)"
  >
    <mat-icon class="text-danger">close</mat-icon>
  </div>
  <div
    class="right-icons-container mt-2"
    [class.d-none]="!hasValue"
    (click)="download($event)"
  >
    <fa-icon [icon]="faDownload" />
  </div>

  <ng-container *ngIf="file">
    <fa-icon class="img-icon" [icon]="faFileUpload"></fa-icon>
    <div class="document-name">
      {{ descricao }}
    </div>
  </ng-container>

  <div class="img-preview-container" [class.d-none]="!hasValue || isNonImage">
    <img class="img-fluid" #docPreview />
  </div>
  <ng-container *ngIf="!file">
    <div
      [class.d-none]="!hasValue"
      *ngIf="isNonImage"
      class="file-extension-preview"
    >
      <div class="file"></div>
      <div class="file-extension-preview-text">.{{ fileExtension }}</div>
    </div>
    <fa-icon
      class="img-icon"
      [icon]="faFileUpload"
      [class.d-none]="hasValue"
    ></fa-icon>
    <div class="document-name">
      <div>
        {{ descricao }}
      </div>
    </div>
    <input type="file" class="d-none" #inputFile (change)="onInput($event)" />
  </ng-container>
</div>
